<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="litigesSvc"></yo-generic-datagrid-pn>
